
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getAbExperimentFilterData",
      resolverType: "query",
      routePath: "/getAbExperimentFilterData",
      httpMethod: "POST",
    });
  